import styled from 'styled-components'

import { applyIPadOnlyStyle } from 'helpers/css'
import { isIPad, isIPhone } from 'utils/device'

export const Container = styled.div`
    width: 75vw;
    height: 48vh;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;

    background: linear-gradient(0deg, #ffffff, #ffffff), #cfd8dc;
    box-shadow: -16px -16px 40px rgba(253, 255, 255, 0.4),
        16px 16px 40px rgba(187, 195, 206, 0.3);
    border-radius: 16px;
    border: #eeeeee solid 1px;

    cursor: default;

    & > div {
        flex-basis: 50%;
    }

    @media (min-width: 768px) and (max-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) {
        & > div {
            flex-basis: 70%;
        }
    }

    ${(isIPhone || isIPad) && `display: table;`}

    ${props => {
        const { error } = props

        if (!error) {
            return applyIPadOnlyStyle(
                `height: 100vh,
        width: 100vw,
        border-radius: 0,
        background: #2e2e2e,
        box-shadow: 10px 10px 40px 3px #0000004d,
        flex-direction: column,
        border: none,
        display: block,
        `,
                {
                    min: 0,
                    max: 1370,
                    orientation: 'both',
                }
            )
        }

        return applyIPadOnlyStyle(
            `
         height: max-content,
         width: max-content,
     background: #555555,
     flex-direction: column,
     margin: 15% 10%,
     border-radius: 20px,
     border: none,
     box-shadow: none,
     background: transparent,
     display: block,
     `,
            {
                min: 0,
                max: 1370,
                orientation: 'both',
            }
        )
    }}
    ${props => {
        const { error } = props

        if (!error) {
            return applyIPadOnlyStyle(
                `height: 100vh,
        width: 100vw,
        border-radius: 0,
        background: #2e2e2e,
        box-shadow: 10px 10px 40px 3px #0000004d,
        flex-direction: row,
        padding-right: 5%;
        border: none,
        `,
                {
                    min: 0,
                    max: 1370,
                    orientation: 'landscape',
                }
            )
        }
    }};
`
